import React from 'react'

import CollegeCrest from '@scoir/college-crest'
import { omit } from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { selectProspectName } from 'store/prospects'

export const AccessibleCollegeCrest = ({ scid, name, ...rest }) => {
  const props = omit(rest, ['dispatch'])
  return (
    <CollegeCrest
      scid={scid}
      alt={name}
      {...props}
    />
  )
}

AccessibleCollegeCrest.propTypes = {
  scid: PropTypes.number,
  name: PropTypes.string,
}

export default connect((store, { scid }) => ({
  name: selectProspectName(store, scid),
}))(AccessibleCollegeCrest)
